import type { ComponentProps, PropsWithChildren } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import type { Nullable } from 'corgi-types';
import { flex, space } from 'styled-system';

import { overflowX, overflowY } from 'common/theme/system-utilities';
import ReclamationDrawerFormHeadline from './ReclamationDrawerFormHeadline';

interface ReclamationDrawerBodyProps extends PropsWithChildren {
  claimedQuantity: number;
  productName: string;
  productVariantName: string;
  productImage: Nullable<string>;
  shopName?: string;
}

const UnstyledBody = styled.div<any>`
  ${flex};
  ${overflowY};
  ${overflowX};
`;

const Body = (props: ComponentProps<typeof UnstyledBody>) => (
  <UnstyledBody flex="1 1 auto" overflowY="auto" overflowX="hidden" {...props} />
);

const UnstyledBodyInner = styled.div<any>`
  ${space};
`;

const BodyInner = (props: ComponentProps<typeof UnstyledBodyInner>) => (
  <UnstyledBodyInner p="sp_16" {...props} />
);

const ReclamationDrawerBody = ({
  claimedQuantity,
  productName,
  productVariantName,
  productImage,
  shopName,
  children,
}: ReclamationDrawerBodyProps) => (
  <Body>
    <ReclamationDrawerFormHeadline
      claimedQuantity={claimedQuantity}
      src={productImage}
      title={productName}
      shopName={shopName}
      subtitle={productVariantName}
    />
    <BodyInner>{children}</BodyInner>
  </Body>
);

export default ReclamationDrawerBody;
